import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import { alpha } from '@mui/material/styles';
/**
 * Sample testimonials provide social proof to prospective clients.  They
 * demonstrate the impact of the company's services in a concise and
 * personal manner.  Replace or extend these entries with real feedback
 * once available.
 */
const testimonials = [
  {
    quote:
      'Gracias a Acopiaserwa, logramos nacionalizar nuestra mercancía sin contratiempos. Su equipo nos guió en todo el proceso aduanero de forma profesional y rápida. ¡Altamente recomendados!',
    author: 'María García – Importadora TexMar',
  },
  {
    quote:
      'Acopiaserwa se ha convertido en un aliado clave para nuestro negocio. Su conocimiento del comercio fronterizo Colombia–Venezuela nos permitió expandir operaciones con costos reducidos y mayor eficiencia.',
    author: 'Luis Fernández – CEO de AgroExport',
  },
];

const Testimonials = () => {
  const pearl = '#FFFFFF';
  const pearlGlass = alpha(pearl, 0.72);
  return (
  <Box id="testimonios" sx={{ py: 8 }}>
    <Container>
      <Typography
     variant="h3"
        component="h2"
        textAlign="center"
              sx={{
          mb: 4,
          fontWeight: 600,
            display: 'block',
          px: 2,
             pt: 0.5,
          pb: 1.5,
          bgcolor: pearlGlass,
          color: 'text.primary',
          backdropFilter: 'blur(6px)',
          borderRadius: 1,
        }}
      >
        Testimonios de Clientes
      </Typography>
      <Grid container spacing={4}>
        {testimonials.map((t) => (
          <Grid item xs={12} md={6} key={t.author}>
          <Card elevation={0} sx={{ height: '100%', backgroundColor: 'background.paper', boxShadow: '0px 6px 20px rgba(0,0,0,0.06)', p: 2 }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Avatar sx={{ mr: 2 }}>{t.author.charAt(0)}</Avatar>
                  <Typography variant="subtitle2" color="text.secondary">
                    {t.author}
                  </Typography>
                </Box>
                <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
                  “{t.quote}”
                </Typography>
         
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
  );
};

export default Testimonials;